var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-detail"},[_c('div',{staticClass:"app-detail__version-notes"},[_c('div',{staticClass:"version"},[_vm._v(" v."+_vm._s(_vm.version)+" ")]),_c('button',{staticClass:"app-detail__version-button",on:{"click":function($event){return _vm.$emit('displayReleaseNotes')}}},[_vm._v("Release Notes")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }